import React, {useState, useEffect} from 'react'
import {  Container, Row, Col } from 'react-bootstrap'


import "../buidl.css";


function Moreintro() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    // const handleContextMenu = (e) => {
    //   e.preventDefault(); // Disable right-click
    // };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"#FFFFFF",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh',
      paddingBottom: isSmallScreen ? '5rem' : 'auto',
       paddingTop: isSmallScreen ? '5rem' : 'auto',
      }}>
      <Row style={{ height: "auto", width: "100%"}}>
        <Col xs={12} md={4} lg={4}> <h2 style={{fontWeight:"bold",fontSize:"3rem"}}>Context<br /> Behind</h2></Col>
        <Col xs={12} md={8} lg={8}>
        <Row><p style={{fontSize:"0.82rem"}}>The platform addresses the challenges of team formation, task management, and secure payments in fast-paced digital project environments.</p></Row>
         <Row>
           <Col xs={12} md={6} lg={6}>
            <h5 style={{fontWeight:"bold",fontSize:"1.8rem"}}>Tasks</h5>
             <p style={{fontSize:"0.82rem"}}>Design and develop Buidl — an AI-powered platform that connects founders, project managers, and freelancers by automating talent matching, streamlining project management, and integrating payments, cloud storage, and real-time collaboration tools.</p>
           </Col>
            <Col xs={12} md={6} lg={6}>
             <h5 style={{fontWeight:"bold",fontSize:"1.8rem"}}>Problem</h5>
             <p style={{fontSize:"0.82rem"}}>Many founders and freelancers struggle to find the right collaborators quickly and manage projects efficiently. Current platforms lack intelligent matching, integrated workflows, and seamless communication tools.</p>
            </Col>
         </Row>
         <Row>
           <Col xs={12} md={6} lg={6}>
           <h5 style={{fontWeight:"bold",fontSize:"1.8rem"}}>Solutions</h5>
           <p style={{fontSize:"0.82rem"}}>Buidl streamlines collaboration by using AI to match founders with the right talent and manage projects efficiently. It integrates payments, cloud storage, and real-time communication to support seamless teamwork from idea to delivery.</p>
           </Col>
            <Col xs={12} md={6} lg={6}>
            <h5 style={{fontWeight:"bold",fontSize:"1.8rem"}}>Key features</h5>
            <p style={{fontSize:"0.82rem"}}>Buidl offers AI-powered talent matching, task management, and integrated wallets for seamless payments. It also includes real-time chatrooms and cloud-based resource sharing to enhance project collaboration.</p>
            </Col>
         </Row>
        </Col>
      </Row>
    </Container>
    
     
    
  )
}

export default Moreintro